// Post type keys
export type PostTypeKey = 'post' | 'movie' | 'comic' | 'game' | 'novel' |'search';

// Type keys for API lists
export enum TypeKeyListApi {
  BANNER = 'slider',
  CHAT_HOME = 'homechat',
  BLOCK_LABEL = 'blocklabel',
  LIST_ITEM_TAB = 'itemstab',
  LIST_SLIDER = 'itemslider',
  LIST_HORIZONTAL = 'itemshorizontal',
  SPACE = 'space',
  TYPE_TABS = 'type_tabs',
  POST_TYPE = 'posttype_slider',
  LIST_VERTICAL = 'itemslist',
  ITEM_GRID = 'itemgrid',
}
// Constants for post types
export enum POST_TYPES {
  MOVIES = 'movie',
  GAMES = 'game',
  COMIC = 'comic',
  NOVEL = 'novel',
}
